import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

const ENJOYMENT_ENTERTAINMENT_ROWS = [
  'Praise and Encouragement',
  'Mini-matches (short courts)',
  'Short Games',
  'Mixed Ability Groups',
  'Parent-Child Play',
  'Recreational Sessions',
  'Team Games and Socializing',
  'Multi-Sports',
  'Skill Challenges',
  'Competitions',
  'Gamified (Tech) Practice',
  'Leaderboard',
] as const;

export function EnjoymentEntertainmentTable() {
  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Fun, social, and game-like activities that keep players engaged while building long-term participation.
      </Typography>
      <TableContainer sx={{ border: '1px solid #ffe0b2', borderRadius: 1, bgcolor: '#fff' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: '#fff7ed' }}>
              <TableCell sx={{ fontWeight: 700 }}>Approach / Activities</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {ENJOYMENT_ENTERTAINMENT_ROWS.map((activity) => (
              <TableRow key={activity}>
                <TableCell sx={{ fontWeight: 600 }}>{activity}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
